var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrap"},_vm._l((_vm.buttonArray),function(item){return _c('button',{class:item.className},[_vm._v(_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }